export default {

  'comparison_analysis_date_comparison_title': "时间对比",
  'comparison_analysis_date_comparison_key_metrics_comparison': "关键指标对比",

  'comparison_analysis_date_comparison_statistics_date': "统计日期",
  'comparison_analysis_date_comparison_contrast_date': "对比日期",
  'comparison_analysis_date_comparison_more_metrics': "更多指标",
  'comparison_analysis_date_comparison_key_metrics': "关键指标",
  'comparison_analysis_date_data_tips': "您当前勾选的对比时间与统计时间日期个数不一致，请重新选择。",
  'comparison_analysis_date_select_tips': "和统计日期保持一致。",

  'nightingale_comparison_analysis_date_comparison_title': "时间对比",
  'nightingale_comparison_analysis_key_performance': '关键指标',
  'nightingale_comparison_analysis_retention_tracking_comparison': '留存追踪对比',
  'nightingale_comparison_analysis_return_rate': '留存率',
  'nightingale_comparison_analysis_rolling_retention': '滚动留存率',
  'nightingale_comparison_analysis_metrics': '指标',
  'nightingale_comparison_analysis_d1_d30': 'D1-D30',
  'nightingale_comparison_analysis_d1_d60': 'D1-D60',
  'nightingale_comparison_analysis_d1_d90': 'D1-D90',
  'nightingale_comparison_analysis_d1': '次留',
  'nightingale_comparison_analysis_d2': '2留',
  'nightingale_comparison_analysis_register_users' : '新进用户',
  'nightingale_comparison_analysis_d': '{num}留',
  'nightingale_comparison_analysis_explain': '{num}留=xx注册日期第{num}天存留用户数/xx注册日期新注册用户数，注册日期是第0天。',
  'pc_console_comparison_romeve_time':'删除时间',
  'pc_console_comparison_Up_to_6_times':'最多可添加4段时间',
  'pc_console_comparison_set_comparsion_time':'设置对比时间',
}
